import { StarIcon } from '@heroicons/react/24/solid';
import React, { useState, useEffect } from 'react';

export default function RatingStars({ size = '20px', rating = 0, color = "yellow" }) {
  const [fRating, setFRating] = useState(0);

  useEffect(() => {
    setFRating(Math.round(rating));
  }, [rating]);

  return (
    <div className='flex flex-wrap items-center'>
      {/* Render 5 stars */}
      {[...Array(5)].map((star, index) => {
        const ratingValue = index + 1;

        return (
          <span key={index}>
            {ratingValue <= fRating ? (
              <StarIcon className={color === "yellow" ? "text-yellow-400" : "text-black"} style={{ height: size, width: size }} />
            ) : (
              <StarIcon className="text-black/20" style={{ height: size, width: size }} />
            )}
          </span>
        );
      })}
    </div>
  );
};
